import React from "react";

/**
 * Kino-Automat CSS — Vorhang, Marquee-Lichterkette, Gold-Shimmer, Ticket-Stub.
 * In eigener Datei, damit die Haupt-Komponente lesbar bleibt.
 */
export default function KioskStyles() {
  return (
    <style>{`
      /* ---------- Vorhang beim Mount ---------- */
      .kiosk-curtain {
        position: fixed; inset: 0; z-index: 60; pointer-events: none;
      }
      .kiosk-curtain-panel {
        position: absolute; top: 0; bottom: 0; width: 52%;
        background:
          repeating-linear-gradient(90deg,
            #3a0a0e 0px, #5a1219 8px, #7A1921 16px, #5a1219 24px, #3a0a0e 32px),
          linear-gradient(180deg, #4a1015 0%, #2a0509 100%);
        box-shadow: 0 0 60px rgba(0,0,0,0.9) inset, 0 0 30px rgba(0,0,0,0.8);
        transition: transform 1400ms cubic-bezier(0.65, 0.02, 0.35, 1.0);
      }
      .kiosk-curtain-panel::before {
        content: ""; position: absolute; top: 0; bottom: 0; width: 100%;
        background: linear-gradient(180deg, rgba(0,0,0,0.4) 0%, transparent 20%, transparent 80%, rgba(0,0,0,0.6) 100%);
      }
      .kiosk-curtain-left  { left: 0;  transform: translateX(0); }
      .kiosk-curtain-right { right: 0; transform: translateX(0); }
      .kiosk-curtain-open .kiosk-curtain-left  { transform: translateX(-110%); }
      .kiosk-curtain-open .kiosk-curtain-right { transform: translateX(110%); }

      /* ---------- Marquee-Lichterkette ---------- */
      .marquee-bulbs {
        display: flex; gap: 1rem; justify-content: space-around; align-items: center;
        padding: 0 0.5rem;
      }
      .marquee-bulbs > span {
        width: 8px; height: 8px; border-radius: 50%;
        background: radial-gradient(circle at 30% 30%, #FFF3C4 0%, #EEDC82 35%, #D4AF37 65%, #7a5a10 100%);
        box-shadow: 0 0 10px rgba(238,220,130,0.85), 0 0 22px rgba(212,175,55,0.5);
        animation: bulb-blink 1.6s ease-in-out infinite;
        flex-shrink: 0;
      }
      .marquee-bulbs > span:nth-child(2n)   { animation-delay: 0.2s; }
      .marquee-bulbs > span:nth-child(3n)   { animation-delay: 0.5s; }
      .marquee-bulbs > span:nth-child(4n+1) { animation-delay: 0.9s; }
      @keyframes bulb-blink {
        0%, 100% { opacity: 0.55; transform: scale(0.9); }
        50%      { opacity: 1;    transform: scale(1.15); }
      }

      /* ---------- Gold-Shimmer für Titel ---------- */
      .gold-shimmer {
        background: linear-gradient(90deg, #D4AF37 0%, #FFF3C4 30%, #EEDC82 50%, #FFF3C4 70%, #D4AF37 100%);
        background-size: 200% 100%;
        -webkit-background-clip: text; background-clip: text;
        -webkit-text-fill-color: transparent; color: transparent;
        animation: shimmer 6s linear infinite;
      }
      @keyframes shimmer {
        0%   { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }

      /* ---------- Ticket-Stub (Bestätigung) ---------- */
      .ticket-stub {
        display: grid;
        grid-template-columns: 1fr auto auto;
        background: linear-gradient(135deg, #0F0D08 0%, #1a1508 50%, #0F0D08 100%);
        border: 1px solid rgba(212, 175, 55, 0.35);
        border-radius: 14px;
        box-shadow:
          0 0 40px rgba(212, 175, 55, 0.15),
          0 20px 50px rgba(0,0,0,0.6),
          inset 0 0 60px rgba(212, 175, 55, 0.04);
        overflow: hidden;
        position: relative;
      }
      .ticket-stub::before, .ticket-stub::after {
        content: ""; position: absolute; left: 0; right: 0; height: 8px;
        background:
          repeating-linear-gradient(90deg, transparent 0 12px, rgba(212,175,55,0.2) 12px 14px);
      }
      .ticket-stub::before { top: 0; }
      .ticket-stub::after  { bottom: 0; }
      .ticket-stub-main { padding: 2.5rem 2rem; }
      .ticket-stub-side {
        padding: 2rem 1.5rem; display: flex; flex-direction: column;
        align-items: center; justify-content: center;
        background: linear-gradient(180deg, rgba(212, 175, 55, 0.05) 0%, transparent 100%);
      }
      .ticket-stub-perf {
        position: relative; width: 2px;
        background: repeating-linear-gradient(180deg, transparent 0 8px, rgba(212,175,55,0.4) 8px 14px);
        margin: 1.5rem 0;
      }
      .ticket-stub-perf::before, .ticket-stub-perf::after {
        content: ""; position: absolute; left: 50%; transform: translateX(-50%);
        width: 20px; height: 20px; border-radius: 50%;
        background: #000; border: 1px solid rgba(212,175,55,0.35);
      }
      .ticket-stub-perf::before { top: -22px; }
      .ticket-stub-perf::after  { bottom: -22px; }

      .ticket-reveal {
        animation: stub-in 800ms cubic-bezier(0.16, 1, 0.3, 1) both;
      }
      @keyframes stub-in {
        0%   { opacity: 0; transform: translateY(28px) scale(0.96); }
        100% { opacity: 1; transform: translateY(0)    scale(1);    }
      }

      /* ---------- Mobile-Fallback für Ticket-Stub ---------- */
      @media (max-width: 768px) {
        .ticket-stub { grid-template-columns: 1fr; grid-template-rows: auto auto auto; }
        .ticket-stub-perf {
          width: 100%; height: 2px; margin: 0 1.5rem;
          background: repeating-linear-gradient(90deg, transparent 0 8px, rgba(212,175,55,0.4) 8px 14px);
        }
        .ticket-stub-perf::before, .ticket-stub-perf::after {
          top: 50%; transform: translate(0, -50%);
        }
        .ticket-stub-perf::before { left: -22px; }
        .ticket-stub-perf::after  { left: auto; right: -22px; }
      }
    `}</style>
  );
}
